export class Validator {

    constructor(items, settings) {

        this.items = items;
        let defaults = {
            errorClass: 'validation-error'
        };

        this.set = Object.extend(true, defaults, settings);
        this.setupFunctions();

    }

    validate() {

        let result = {};

        let valid = true;

        for (let item of this.items) {
            let value = item.get();
            if (item.validate && !this.isValid(value, item.validate)) {
                valid = false;
                if (this.set.errorClass) item.element.classList.add(this.set.errorClass);
                if (item.error) {
                    item.error.element.innerHTML = item.error.message;
                }
            }
            else {
                result[item.name] = value;
                if (item.error) {
                    item.error.element.innerHTML = '';
                }
                if (this.set.errorClass && item.element) item.element.classList.remove(this.set.errorClass);
            }
        }

        if (valid) return result;
        return false;

    }

    isValid(value, validations) {

        if (!validations) return true;

        for (let validation in validations) {
            if (!this.func[validation](value, validations[validation])) return false;
        }

        return true;

    }

    setupFunctions() {
        this.func = {
            'strMinLen': function(value, len) {
                return typeof(value) === 'string' && value.length >= len;
            },
            'arrayMinLen': function(value, len) {
                return Array.isArray(value) && value.length >= len;
            },
            'true': function(value) {
                return value;
            },
            'dateRange': function(value) {
                return value.from instanceof Date && !isNaN(value.from) && value.to instanceof Date && !isNaN(value.to);
            },
            'date': function(value) {
                return value instanceof Date && !isNaN(value);
            },            
            'id' : function(value) {
                return Number.isInteger(value) && value != 0;
            }
        };




    }

    


}